import {Coordinates, Markers, Partition, VariableID, WidgetBase, WidgetType} from "@/api/types";

export const widgetDataMappingByType = (widgetType: WidgetType) => {
	switch (widgetType) {
		case "bar":
		case "gauge":
			return ["variable", "partition"];
		case "graph":
		case "single":
			return ["variable"];
		case "value_with_range":
			return ["variable", "application", "value", "min", "max", "rangeSettingsType"];
		case "map":
			return ["markers"];
		case "weather":
			return ["locationName", "unit", "coordinates"];
		case "tank_level_application":
			return ["processID"];
		case "active_alarms":
			return ["showWarnings", "showAlarms", "showErrors"];
		default:
			return [];
	}
};

export class WidgetHandler {
	cardID: string;
	dashboardID: string;
	dashboardIMOnly: boolean;

	readonly widgetID: string;
	readonly type: WidgetBase["type"];

	coordinates?: Coordinates;
	partition?: Partition;
	variable?: VariableID;

  application?: string;
  value?: string;
	min?: number;
	max?: number;
  rangeSettingsType?: string;

	locationName?: string;
	unit?: "metric" | "imperial" | "standard";
	processID?: string;
	markers?: Markers;

	locationDetails = {
		country: "",
		name: "",
	};

	showWarnings?: boolean;
	showAlarms?: boolean;
	showErrors?: boolean;

	constructor(
		widget: WidgetBase,
		cardID: string,
		dashboardID: string,
		dashboardIMOnly: boolean
	) {
		this.cardID = cardID;
		this.dashboardID = dashboardID;
		this.dashboardIMOnly = dashboardIMOnly;
		this.widgetID = widget.id;
		this.type = widget.type;

		this.setWidgetSpecificData(widget.data);
	}

	setWidgetSpecificData(data: WidgetBase["data"]) {
		if (!data) return;

		Object.entries(data).forEach(([key, value]) => {
			this[key as keyof this] = value as this[keyof this];
		});
	}

	getWidgetSpecificData() {
		const widgetData: Partial<WidgetBase["data"]> = {};

		widgetDataMappingByType(this.type).forEach((key) => {
			widgetData[key as keyof WidgetBase["data"]] = this[key as keyof this] as never;
		});

		return widgetData;
	}
}
